<template>
  <div class="container">
<!--     <nav-bar rightShow="false" @leftClick="leftClick"></nav-bar> -->
    <div class="content">
      <div class="pic" :style="{backgroundImage: 'url('+imgSrc+')'}"></div>
      <div class="versionInfo" v-if="update === 2">
        <p class="v-item">当前版为<span>{{version}}</span></p>
        <p class="v-item">最新版本为<span>{{newVersion}}</span></p>
        <div class="text">
          <p>点击“预约升级”后</p>
          <p>我们将在一周内给您升级</p>
        </div>
      </div>
      <div class="content-text" v-if="update === 1 || update === 3">
        <p>您已预约升级</p>
        <p>我们将在一周内给您升级</p>
      </div>
      <div class="content-text" v-if="update === 0">
        <p>当前版本为<span>{{version}}</span></p>
      </div>
      <button class="btn-block btn" :class="update !== 2 ? 'disable' : ''" v-text="upText()" @click="appointment()"></button>
    </div>
  </div>
</template>
<script>
import NavBar from '../../components/NavBar/NavBar.vue'
import axios from 'axios'
import Common from '../../assets/js/common.js'
var api = process.env.BASE_URL
var isLocal = Common.getEvn()
export default {
  components: {
    NavBar
  },
  data () {
    return {
      update: this.$route.query.upgrade,
      version: this.$route.query.version,
      newVersion: this.$route.query.newVersion,
      imgSrc: Common.staticHref() + 'img/update.jpg',
      deviceId: localStorage.getItem('max_device_id')
    }
  },
  methods: {
    appointment () {
      if (this.update !== 2) return false
      this.setUpdate()
    },
    leftClick () {
      this.$router.back(-1)
    },
    upText () {
      if (this.update === 2) {
        return '预约升级'
      } else if (this.update === 1 || this.update === 3) {
        return '已预约升级'
      } else {
        return '已是最新版'
      }
    },
    setUpdate () {
      if (isLocal === 'local') {
        axios.post('/Calendar/api/version/get/version/info/', {
          device_id: this.deviceId
        })
        .then(this.getVersionInfoSucc)
        .catch(this.getVersionInfoError)
      } else {
        axios.post(api + '/Calendar/api/version/get/version/info/', {
          device_id: this.deviceId
        })
        .then(this.getVersionInfoSucc)
        .catch(this.getVersionInfoError)
      }
    },
    getVersionInfoSucc (res) {
      let _res = res.data
      if (_res) {
        let _result = _res.result
        if (_result === 0) {
          this.$createToast({
            type: 'correct',
            txt: '预约升级成功',
            time: 2000
          }).show()
          this.update = 3
        } else if (_result === 1) {
          console.log(_res.message)
        }
      }
    },
    getVersionInfoError (error) {
      console.log(error)
    }
  },
  mounted () {
    Common.setTitle('版本升级')
  }
}
</script>
<style lang="stylus" scoped>
.content
  background #ffffff
  padding 20.7vh 25px 0
  box-sizing border-box
  height 100%
  /* margin-top 15px */
  position relative
  .pic
    width 28.6vh
    height 28.6vh
    margin 0 auto
    background-position center center
    background-repeat no-repeat
    background-size contain
  p
    font-size 15px
    color #333333
    text-align center
    line-height 22px
  .versionInfo
    padding-top 1.4vh
    .v-item
      padding-top 11px
    .text
      padding-top 8vh
  .content-text
    padding-top 5.72vh
  .btn
    position absolute
    bottom 3.15vh
    width calc(100% - 50px)
  .disable
    background #666666
</style>


// WEBPACK FOOTER //
// src/pages/UpdateDetail/UpdateDetail.vue